var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "py-6" }, [
    _c("h3", { staticClass: "text-lg font-medium mb-4" }, [
      _vm._v("Step 9 of 9: Additional Notes"),
    ]),
    _c(
      "div",
      { staticClass: "grid grid-cols-2 gap-3" },
      [
        _c("ValidationProvider", {
          staticClass: "col-span-2",
          attrs: { name: "Special Instructions" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "Special Instructions", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Special Instructions "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormTextarea", {
                        attrs: {
                          name: "additional_special_instructions",
                          customBorderClass: "borderTen",
                          "rows:": 4,
                          placeholder: "Type here",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField(
                              "additional_special_instructions",
                              val
                            ),
                        },
                        model: {
                          value: _vm.formData.additional_special_instructions,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "additional_special_instructions",
                              $$v
                            )
                          },
                          expression:
                            "formData.additional_special_instructions",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          staticClass: "col-span-2",
          attrs: { name: "General Notes" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "General Notes", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("General Notes "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormTextarea", {
                        attrs: {
                          name: "additional_general_notes",
                          customBorderClass: "borderTen",
                          "rows:": 4,
                          placeholder: "Type here",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("additional_general_notes", val),
                        },
                        model: {
                          value: _vm.formData.additional_general_notes,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "additional_general_notes",
                              $$v
                            )
                          },
                          expression: "formData.additional_general_notes",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          staticClass: "col-span-2",
          attrs: { name: "Other Information" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Other Information "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormTextarea", {
                        attrs: {
                          name: "additional_other_information",
                          "rows:": 4,
                          placeholder: "Type here",
                          customBorderClass: "borderTen",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField(
                              "additional_other_information",
                              val
                            ),
                        },
                        model: {
                          value: _vm.formData.additional_other_information,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "additional_other_information",
                              $$v
                            )
                          },
                          expression: "formData.additional_other_information",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }